<div class="breadcrumbs">
  <span class="title">Lista DPGR<mat-icon style="vertical-align: middle;">keyboard_arrow_right
    </mat-icon> Lista invio segnalazioni DPGR </span>
</div>
<hr>
<div class="titolo flex-display">
  <span class="h1 upp">Lista Invio segnalazioni DPGR</span>
</div>

<mat-expansion-panel class='rett' hideToggle (opened)="arrowFlag = !arrowFlag" (closed)='arrowFlag = !arrowFlag'>
  <mat-expansion-panel-header class="colorSearch">
    <mat-panel-title class='search'>
      <mat-icon>search</mat-icon>
      <strong class="title">CERCA</strong>
      <mat-icon *ngIf="arrowFlag">keyboard_arrow_up</mat-icon>
      <mat-icon *ngIf="!arrowFlag">keyboard_arrow_down</mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="coloredS" [formGroup]="form">
    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>ID Invio</mat-label>
        <input matInput [formControlName]="'idInvio'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>DPGR</mat-label>
        <input matInput [formControlName]="'dpgr'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data DPGR da:</mat-label>
        <input matInput [matDatepicker]="pickerDpgrDa" [formControlName]="'dataEventoDa'" class='searchbar'>
        <mat-datepicker-toggle matSuffix [for]="pickerDpgrDa"></mat-datepicker-toggle>
        <mat-datepicker #pickerDpgrDa></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data DPGR a:</mat-label>
        <input matInput [matDatepicker]="pickerDpgrA" [formControlName]="'dataEventoA'" class='searchbar'>
        <mat-datepicker-toggle matSuffix [for]="pickerDpgrA"></mat-datepicker-toggle>
        <mat-datepicker #pickerDpgrA></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Numero protocollo Ente Attuatore</mat-label>
        <input matInput [formControlName]="'numProtoEnteAt'" class='searchbar'>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data protocollo Ente Attuatore</mat-label>
        <input matInput [matDatepicker]="picker2" [formControlName]="'dataProtoEnteAt'" class='searchbar'>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Numero protocollo RVE</mat-label>
        <input matInput [formControlName]="'numProtoRve'" class='searchbar'>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data protocollo RVE</mat-label>
        <input matInput [matDatepicker]="picker3" [formControlName]="'dataProtoRve'" class='searchbar'>
        <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
        <mat-datepicker #picker3></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data creazione</mat-label>
        <input matInput [formControlName]="'dataCreazione'" [matDatepicker]="picker1">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Stato</mat-label>
        <input matInput [formControlName]="'stato'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>File caricato</mat-label>
        <mat-select [formControlName]="'fileCaricato'">
          <mat-option value=''></mat-option>
          <mat-option value='SI'> SI </mat-option>
          <mat-option value='NO'> NO </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <mat-action-row class='colored'>
    <button mat-stroked-button class="pers2" color="warn" (click)="onReset()">Reset</button>
    <button mat-raised-button class="pers2" color="accent" (click)="ricercaListaSegnalazioni()">Cerca</button>
  </mat-action-row>
</mat-expansion-panel>


<mat-table [dataSource]="dataSource" matSort matSortActive="idInvio" matSortDirection="asc" matSortDisableClear>

  <ng-container matColumnDef="idInvio">
    <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
    <mat-cell [attr.data-label]="'idInvio'" *matCellDef="let element"> {{element.idInvio}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dpgr">
    <mat-header-cell *matHeaderCellDef mat-sort-header> DPGR </mat-header-cell>
    <mat-cell [attr.data-label]="'DPGR'" *matCellDef="let element"> {{element.dpgr}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dataEvento">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Data DPGR </mat-header-cell>
    <mat-cell [attr.data-label]="'DATA DPGR:'" *matCellDef="let element"> {{element.dataEvento | date: 'dd/MM/yyyy'}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="dataCreazione">
    <mat-header-cell *matHeaderCellDef mat-sort-header><div class="whitespace"> Data Creazione </div></mat-header-cell>
    <mat-cell [attr.data-label]="'dataCreazione'" *matCellDef="let element"> {{element.dataCreazione | date: 'dd/MM/yyyy'}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="stato">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Stato </mat-header-cell>
    <mat-cell [attr.data-label]="'stato'" *matCellDef="let element"> {{element.stato}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="fileCaricato">
    <mat-header-cell *matHeaderCellDef mat-sort-header> File Caricato </mat-header-cell>
    <mat-cell [attr.data-label]="'fileCaricato'" *matCellDef="let element">
      <span *ngIf="element.fileCaricato == 'SI'">SI</span>
      <span *ngIf="element.fileCaricato == null">NO</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="numProtoEnteAt">
    <mat-header-cell *matHeaderCellDef mat-sort-header><div class="whitespace"> Numero Protocollo Ente Attuatore </div></mat-header-cell>
    <mat-cell [attr.data-label]="'numProtoEnteAt'" *matCellDef="let element"> {{element.numProtoEnteAt}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dataProtoEnteAt">
    <mat-header-cell *matHeaderCellDef mat-sort-header><div class="whitespace"> Data Protocollo Ente Attuatore </div></mat-header-cell>
    <mat-cell [attr.data-label]="'dataProtoEnteAt:'" *matCellDef="let element"> {{element.dataProtoEnteAt | date: 'dd/MM/yyyy'}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="numProtoRve">
    <mat-header-cell *matHeaderCellDef mat-sort-header><div class="whitespace"> Numero Protocollo RVE </div></mat-header-cell>
    <mat-cell [attr.data-label]="'numProtoRve'" *matCellDef="let element"> {{element.numProtoRve}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dataProtoRve">
    <mat-header-cell *matHeaderCellDef mat-sort-header><div class="whitespace"> Data Protocollo RVE </div></mat-header-cell>
    <mat-cell [attr.data-label]="'dataProtoRve'" *matCellDef="let element"> {{element.dataProtoRve | date: 'dd/MM/yyyy'}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef><div class="whitespace"> Azioni </div></mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span *ngIf="element.idInvio !== openToggle" class="material-icons" title="apri/chiudi toolbar"
        (click)="openToggle = element.idInvio">more_horiz</span>

      <myp-toolbar *ngIf="element.idInvio === openToggle" [toolbar]="toolbar" role=toolbar [data]="element"
        [data]="element" (onToolbarEvent)="handleToolbarEvent($event)">
      </myp-toolbar>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns "></mat-header-row>
  <mat-row *matRowDef="let row; columns:displayedColumns"></mat-row>

</mat-table>

<div *ngIf="this.dataSource.counter$.source['value'] === 0">
  <mat-card class="emptyTable">
    <mat-card-content>
      <h6>Non ci sono risultati</h6>
    </mat-card-content>
  </mat-card>
</div>

<mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="risultatiPerPagina"
  [pageSizeOptions]="[3, 5, 10, 100, 300]"></mat-paginator>
